import { render, staticRenderFns } from "./personPassGroupDetails.vue?vue&type=template&id=416ba06d&scoped=true"
import script from "./personPassGroupDetails.vue?vue&type=script&lang=js"
export * from "./personPassGroupDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ba06d",
  null
  
)

export default component.exports